import { addPermissionsToRoute } from '@qsrsoft/myq-core';
const routes = {
  name: 'Sales',
  icon: 'mdi-chart-line',
  path: '/reports/sales',
  menuFilters: {
    $or: [
      {
        $and: [
          { countryCode: { $in: ['us', 'ca'] } },
          { enterpriseClient: { $eq: 'Tim_Hortons_MT' } },
        ],
      },
      {
        $and: [
          { countryCode: { $in: ['za'] } },
          { enterpriseClient: { $eq: 'McDonalds' } },
        ],
      },
    ],
  },
  children: [
    {
      path: '/reports/sales/salesLedger',
      name: 'Sales Ledger',
      meta: { id: 'mc-salesLedger', permission: 'mtSales' },
      component: () => import('./SalesLedger.vue'),
      ...addPermissionsToRoute(['mtSales']),
      menuFilters: {
        $or: [
          {
            $and: [
              { countryCode: { $in: ['us', 'ca'] } },
              { enterpriseClient: { $eq: 'Tim_Hortons_MT' } },
            ],
          },
          {
            $and: [
              { countryCode: { $in: ['za'] } },
              { enterpriseClient: { $eq: 'McDonalds' } },
            ],
          },
        ],
      },
    },
    {
      path: '/reports/sales/salesPointOfOrder',
      name: 'Sales - Point Of Order',
      meta: { id: 'mc-salesPointOfOrder', permission: 'mtSales' },
      component: () => import('./SalesPointOfOrder.vue'),
      ...addPermissionsToRoute(['mtSales']),
      menuFilters: {
        $or: [
          {
            $and: [
              { countryCode: { $in: ['us', 'ca'] } },
              { enterpriseClient: { $eq: 'Tim_Hortons_MT' } },
            ],
          },
          {
            $and: [
              { countryCode: { $in: ['za'] } },
              { enterpriseClient: { $eq: 'McDonalds' } },
            ],
          },
        ],
      },
    },
    {
      path: '/reports/timhortons/sales/salesDetail',
      name: 'Sales Detail',
      meta: { id: 'reports-SalesDetail', permission: 'mtSales' },
      component: () => import('./SalesDetail.vue'),
      ...addPermissionsToRoute(['mtSales']),
      menuFilters: {
        $and: [
          { countryCode: { $in: ['us', 'ca'] } },
          { enterpriseClient: { $eq: 'Tim_Hortons_MT' } },
        ],
      },
    },
    {
      path: '/reports/timhortons/sales/qboDailySales',
      name: 'QBO Daily Sales',
      meta: { id: 'reports-thQboDailySales', permission: 'mtSales' },
      component: () => import('./QboDailySales.vue'),
      ...addPermissionsToRoute(['mtSales']),
      menuFilters: {
        $and: [
          { countryCode: { $in: ['us', 'ca'] } },
          { enterpriseClient: { $eq: 'Tim_Hortons_MT' } },
        ],
      },
    },
    {
      path: '/reports/timhortons/sales/closingHour',
      name: 'Closing Hour',
      meta: {
        id: 'reports-thSalesClosingHour',
        permission: 'mtSales',
      },
      component: () => import('./ClosingHour.vue'),
      ...addPermissionsToRoute(['mtSales']),
      menuFilters: {
        $and: [
          { countryCode: { $in: ['us', 'ca'] } },
          { enterpriseClient: { $eq: 'Tim_Hortons_MT' } },
        ],
      },
    },
  ],
};

export default routes;
